/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AutopilotFeedStatusQueryVariables = {
    orgRelayId: string;
    timeZone: string;
};
export type AutopilotFeedStatusQueryResponse = {
    readonly org: {
        readonly tailoredDefragCardSummary?: ({
            readonly __typename: "TailoredDefragCardSummary";
            readonly defragTime: unknown;
            readonly yourEventMoves: ReadonlyArray<{
                readonly event: {
                    readonly title: string | null;
                };
            }>;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        }) | null | undefined;
        readonly " $fragmentRefs": FragmentRefs<"AutopilotFeedStatus_org" | "TailoredDefragSummaryCard_org">;
    } | null;
    readonly viewer: {
        readonly user: {
            readonly " $fragmentRefs": FragmentRefs<"AutopilotFeedStatus_user">;
        } | null;
    };
};
export type AutopilotFeedStatusQuery = {
    readonly response: AutopilotFeedStatusQueryResponse;
    readonly variables: AutopilotFeedStatusQueryVariables;
};



/*
query AutopilotFeedStatusQuery(
  $orgRelayId: ID!
  $timeZone: String!
) {
  org: node(id: $orgRelayId) {
    __typename
    ... on Org {
      ...AutopilotFeedStatus_org_3k5A6X
      ...TailoredDefragSummaryCard_org
      tailoredDefragCardSummary {
        __typename
        ... on TailoredDefragCardSummary {
          defragTime
          yourEventMoves {
            event {
              title
            }
          }
        }
      }
    }
    id
  }
  viewer {
    user {
      ...AutopilotFeedStatus_user
      id
    }
    id
  }
}

fragment AutopilotFeedStatusFinished_org on Org {
  nextDefragTime {
    __typename
    ... on DefragTime {
      millis
    }
  }
  tailoredDefragCardSummary {
    __typename
    ... on TailoredDefragCardSummary {
      yourEventMoves {
        event {
          title
        }
      }
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
}

fragment AutopilotFeedStatusUnstarted_org_3k5A6X on Org {
  id
  nextDefragTime {
    __typename
    ... on DefragTime {
      millis
    }
  }
  autopilotEventsResponse(timeZone: $timeZone) {
    __typename
    ... on AutopilotEventsResponse {
      enabledOrganized {
        eventParentRelayId
        paused
      }
      enabledAttending {
        eventParentRelayId
        paused
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment AutopilotFeedStatus_org_3k5A6X on Org {
  ...AutopilotFeedStatusUnstarted_org_3k5A6X
  ...AutopilotFeedStatusFinished_org
  id
  orgFlowStates(flowKeys: ["DefragRun"]) {
    __typename
    ... on GraphEntityError {
      message
    }
    ... on FlowStateList {
      list {
        id
        flowKey
        current {
          id
          state
          errorMessage
        }
      }
    }
  }
}

fragment AutopilotFeedStatus_user on User {
  createdTime
}

fragment TailoredDefragSummaryAttendeeStats_org on Org {
  ...TailoredDefragSummaryAttendees_org
}

fragment TailoredDefragSummaryAttendeeStats_tailoredDefragCardSummary on TailoredDefragCardSummary {
  defragTime
  impactedOtherCalendarIds
  valueStrings
  yourEventMoves {
    newStartTime {
      dateOrDateTime
    }
    originalStartTime {
      dateOrDateTime
    }
    moveReasons
    event {
      title
      calendarIds
    }
  }
  calendarValueStrings {
    calendarId
    valueStrings
  }
  persons {
    __typename
    ... on PersonList {
      ...TailoredDefragSummaryAttendees_personList
      list {
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        id
      }
    }
  }
}

fragment TailoredDefragSummaryAttendees_org on Org {
  id
}

fragment TailoredDefragSummaryAttendees_personList on PersonList {
  list {
    __typename
    id
    emails
    primaryEmail
    isYou
    userId
    isUser
    profile {
      givenName
      familyName
      externalImageUrl
    }
  }
}

fragment TailoredDefragSummaryCard_org on Org {
  ...TailoredDefragSummaryAttendeeStats_org
  id
  tailoredDefragCardSummary {
    __typename
    ... on TailoredDefragCardSummary {
      ...TailoredDefragSummaryAttendeeStats_tailoredDefragCardSummary
      defragTime
      impactedOtherCalendarIds
      valueStrings
      yourEventMoves {
        ...TailoredDefragSummaryEventsMovedList_eventsMoved
        newStartTime {
          dateOrDateTime
        }
        originalStartTime {
          dateOrDateTime
        }
        moveReasons
        addedRooms
        removedRooms
        event {
          title
          eventKey {
            externalEventId
            id
          }
        }
      }
      persons {
        __typename
        ... on PersonList {
          list {
            primaryEmail
            profile {
              givenName
              familyName
              externalImageUrl
            }
            id
          }
        }
      }
      rooms {
        __typename
        ... on RoomList {
          ...TailoredDefragSummaryEventsMovedList_rooms
          list {
            roomId
            name
            id
          }
        }
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment TailoredDefragSummaryEventMoved_eventMoved on DefragExplainedMove {
  originalStartTime {
    millis
  }
  newStartTime {
    millis
  }
  moveReasons
  addedRooms
  removedRooms
  event {
    title
    startTime {
      millis
    }
    endTime {
      millis
    }
    eventKey {
      externalEventId
      id
    }
  }
}

fragment TailoredDefragSummaryEventMoved_rooms on RoomList {
  list {
    roomId
    name
    id
  }
}

fragment TailoredDefragSummaryEventsMovedList_eventsMoved on DefragExplainedMove {
  ...TailoredDefragSummaryEventMoved_eventMoved
}

fragment TailoredDefragSummaryEventsMovedList_rooms on RoomList {
  ...TailoredDefragSummaryEventMoved_rooms
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "orgRelayId"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "timeZone"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "defragTime",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    } as any, v5 = [
        {
            "kind": "Variable",
            "name": "timeZone",
            "variableName": "timeZone"
        } as any
    ], v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "millis",
        "storageKey": null
    } as any, v8 = [
        (v7 /*: any*/)
    ], v9 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "eventParentRelayId",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "paused",
            "storageKey": null
        } as any
    ], v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v11 = {
        "kind": "InlineFragment",
        "selections": [
            (v10 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v12 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateOrDateTime",
            "storageKey": null
        } as any,
        (v7 /*: any*/)
    ], v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "valueStrings",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "AutopilotFeedStatusQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "tailoredDefragCardSummary",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v3 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DefragExplainedMove",
                                                    "kind": "LinkedField",
                                                    "name": "yourEventMoves",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Event",
                                                            "kind": "LinkedField",
                                                            "name": "event",
                                                            "plural": false,
                                                            "selections": [
                                                                (v4 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "TailoredDefragCardSummary",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "args": (v5 /*: any*/),
                                    "kind": "FragmentSpread",
                                    "name": "AutopilotFeedStatus_org"
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "TailoredDefragSummaryCard_org"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "AutopilotFeedStatus_user"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "AutopilotFeedStatusQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        (v6 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "nextDefragTime",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": (v8 /*: any*/),
                                            "type": "DefragTime",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v5 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "autopilotEventsResponse",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Event",
                                                    "kind": "LinkedField",
                                                    "name": "enabledOrganized",
                                                    "plural": true,
                                                    "selections": (v9 /*: any*/),
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Event",
                                                    "kind": "LinkedField",
                                                    "name": "enabledAttending",
                                                    "plural": true,
                                                    "selections": (v9 /*: any*/),
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "AutopilotEventsResponse",
                                            "abstractKey": null
                                        },
                                        (v11 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "tailoredDefragCardSummary",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DefragExplainedMove",
                                                    "kind": "LinkedField",
                                                    "name": "yourEventMoves",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Event",
                                                            "kind": "LinkedField",
                                                            "name": "event",
                                                            "plural": false,
                                                            "selections": [
                                                                (v4 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "calendarIds",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "EventTime",
                                                                    "kind": "LinkedField",
                                                                    "name": "startTime",
                                                                    "plural": false,
                                                                    "selections": (v8 /*: any*/),
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "EventTime",
                                                                    "kind": "LinkedField",
                                                                    "name": "endTime",
                                                                    "plural": false,
                                                                    "selections": (v8 /*: any*/),
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "EventKey",
                                                                    "kind": "LinkedField",
                                                                    "name": "eventKey",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "externalEventId",
                                                                            "storageKey": null
                                                                        },
                                                                        (v6 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "EventTime",
                                                            "kind": "LinkedField",
                                                            "name": "newStartTime",
                                                            "plural": false,
                                                            "selections": (v12 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "EventTime",
                                                            "kind": "LinkedField",
                                                            "name": "originalStartTime",
                                                            "plural": false,
                                                            "selections": (v12 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "moveReasons",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "addedRooms",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "removedRooms",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v3 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "impactedOtherCalendarIds",
                                                    "storageKey": null
                                                },
                                                (v13 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "TailoredDefragCalendarValueStrings",
                                                    "kind": "LinkedField",
                                                    "name": "calendarValueStrings",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "calendarId",
                                                            "storageKey": null
                                                        },
                                                        (v13 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "persons",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Person",
                                                                    "kind": "LinkedField",
                                                                    "name": "list",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        (v2 /*: any*/),
                                                                        (v6 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "emails",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "primaryEmail",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "isYou",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "userId",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "isUser",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "UserProfile",
                                                                            "kind": "LinkedField",
                                                                            "name": "profile",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "givenName",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "familyName",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "externalImageUrl",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "type": "PersonList",
                                                            "abstractKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "rooms",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Room",
                                                                    "kind": "LinkedField",
                                                                    "name": "list",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "roomId",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "name",
                                                                            "storageKey": null
                                                                        },
                                                                        (v6 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "type": "RoomList",
                                                            "abstractKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "TailoredDefragCardSummary",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v10 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "statusCode",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "GraphEntityError",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "flowKeys",
                                            "value": [
                                                "DefragRun"
                                            ]
                                        }
                                    ],
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "orgFlowStates",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v11 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "FlowState",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        (v6 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "flowKey",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "FlowStatus",
                                                            "kind": "LinkedField",
                                                            "name": "current",
                                                            "plural": false,
                                                            "selections": [
                                                                (v6 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "state",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "errorMessage",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "FlowStateList",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": "orgFlowStates(flowKeys:[\"DefragRun\"])"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "createdTime",
                                    "storageKey": null
                                },
                                (v6 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v6 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "4e2b9381b035d541692d3574800fbe63",
            "id": null,
            "metadata": {},
            "name": "AutopilotFeedStatusQuery",
            "operationKind": "query",
            "text": "query AutopilotFeedStatusQuery(\n  $orgRelayId: ID!\n  $timeZone: String!\n) {\n  org: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      ...AutopilotFeedStatus_org_3k5A6X\n      ...TailoredDefragSummaryCard_org\n      tailoredDefragCardSummary {\n        __typename\n        ... on TailoredDefragCardSummary {\n          defragTime\n          yourEventMoves {\n            event {\n              title\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n  viewer {\n    user {\n      ...AutopilotFeedStatus_user\n      id\n    }\n    id\n  }\n}\n\nfragment AutopilotFeedStatusFinished_org on Org {\n  nextDefragTime {\n    __typename\n    ... on DefragTime {\n      millis\n    }\n  }\n  tailoredDefragCardSummary {\n    __typename\n    ... on TailoredDefragCardSummary {\n      yourEventMoves {\n        event {\n          title\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n}\n\nfragment AutopilotFeedStatusUnstarted_org_3k5A6X on Org {\n  id\n  nextDefragTime {\n    __typename\n    ... on DefragTime {\n      millis\n    }\n  }\n  autopilotEventsResponse(timeZone: $timeZone) {\n    __typename\n    ... on AutopilotEventsResponse {\n      enabledOrganized {\n        eventParentRelayId\n        paused\n      }\n      enabledAttending {\n        eventParentRelayId\n        paused\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment AutopilotFeedStatus_org_3k5A6X on Org {\n  ...AutopilotFeedStatusUnstarted_org_3k5A6X\n  ...AutopilotFeedStatusFinished_org\n  id\n  orgFlowStates(flowKeys: [\"DefragRun\"]) {\n    __typename\n    ... on GraphEntityError {\n      message\n    }\n    ... on FlowStateList {\n      list {\n        id\n        flowKey\n        current {\n          id\n          state\n          errorMessage\n        }\n      }\n    }\n  }\n}\n\nfragment AutopilotFeedStatus_user on User {\n  createdTime\n}\n\nfragment TailoredDefragSummaryAttendeeStats_org on Org {\n  ...TailoredDefragSummaryAttendees_org\n}\n\nfragment TailoredDefragSummaryAttendeeStats_tailoredDefragCardSummary on TailoredDefragCardSummary {\n  defragTime\n  impactedOtherCalendarIds\n  valueStrings\n  yourEventMoves {\n    newStartTime {\n      dateOrDateTime\n    }\n    originalStartTime {\n      dateOrDateTime\n    }\n    moveReasons\n    event {\n      title\n      calendarIds\n    }\n  }\n  calendarValueStrings {\n    calendarId\n    valueStrings\n  }\n  persons {\n    __typename\n    ... on PersonList {\n      ...TailoredDefragSummaryAttendees_personList\n      list {\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment TailoredDefragSummaryAttendees_org on Org {\n  id\n}\n\nfragment TailoredDefragSummaryAttendees_personList on PersonList {\n  list {\n    __typename\n    id\n    emails\n    primaryEmail\n    isYou\n    userId\n    isUser\n    profile {\n      givenName\n      familyName\n      externalImageUrl\n    }\n  }\n}\n\nfragment TailoredDefragSummaryCard_org on Org {\n  ...TailoredDefragSummaryAttendeeStats_org\n  id\n  tailoredDefragCardSummary {\n    __typename\n    ... on TailoredDefragCardSummary {\n      ...TailoredDefragSummaryAttendeeStats_tailoredDefragCardSummary\n      defragTime\n      impactedOtherCalendarIds\n      valueStrings\n      yourEventMoves {\n        ...TailoredDefragSummaryEventsMovedList_eventsMoved\n        newStartTime {\n          dateOrDateTime\n        }\n        originalStartTime {\n          dateOrDateTime\n        }\n        moveReasons\n        addedRooms\n        removedRooms\n        event {\n          title\n          eventKey {\n            externalEventId\n            id\n          }\n        }\n      }\n      persons {\n        __typename\n        ... on PersonList {\n          list {\n            primaryEmail\n            profile {\n              givenName\n              familyName\n              externalImageUrl\n            }\n            id\n          }\n        }\n      }\n      rooms {\n        __typename\n        ... on RoomList {\n          ...TailoredDefragSummaryEventsMovedList_rooms\n          list {\n            roomId\n            name\n            id\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment TailoredDefragSummaryEventMoved_eventMoved on DefragExplainedMove {\n  originalStartTime {\n    millis\n  }\n  newStartTime {\n    millis\n  }\n  moveReasons\n  addedRooms\n  removedRooms\n  event {\n    title\n    startTime {\n      millis\n    }\n    endTime {\n      millis\n    }\n    eventKey {\n      externalEventId\n      id\n    }\n  }\n}\n\nfragment TailoredDefragSummaryEventMoved_rooms on RoomList {\n  list {\n    roomId\n    name\n    id\n  }\n}\n\nfragment TailoredDefragSummaryEventsMovedList_eventsMoved on DefragExplainedMove {\n  ...TailoredDefragSummaryEventMoved_eventMoved\n}\n\nfragment TailoredDefragSummaryEventsMovedList_rooms on RoomList {\n  ...TailoredDefragSummaryEventMoved_rooms\n}\n"
        }
    } as any;
})();
(node as any).hash = '8de95ebe2006cd8b05700b0dc9ea6ab9';
export default node;
